import { render, staticRenderFns } from "./GoogleAds.vue?vue&type=template&id=36822966&"
import script from "./GoogleAds.vue?vue&type=script&lang=js&"
export * from "./GoogleAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports